import { render, staticRenderFns } from "./UserOrderList.vue?vue&type=template&id=2c04dd8a&scoped=true"
import script from "./UserOrderList.vue?vue&type=script&lang=js"
export * from "./UserOrderList.vue?vue&type=script&lang=js"
import style0 from "./UserOrderList.vue?vue&type=style&index=0&id=2c04dd8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c04dd8a",
  null
  
)

export default component.exports